import axios from "axios";
import { CharacterPreset } from "../models/CharacterPreset";
import { Outfit } from "./../models/Outfit";
export class MetadataService {
  static async GetOutfits(): Promise<Outfit[]> {
    try {
      const { data, status } = await axios.get<Outfit[]>(
        "/outfits/Outfits.json"
      );
      return status === 200 ? data : [];
    } catch (err) {
      console.log(err);
      return [];
    }
  }

  static async GetCharacterPresets(): Promise<CharacterPreset[]> {
    try {
      const { data, status } = await axios.get<CharacterPreset[]>(
        "/presets/presets.json"
      );
      return status === 200 && data ? data : [];
    } catch (err) {
      console.log(err);
      return [];
    }
  }
}
